module.exports = "/static/assets/8ee269975ec5e64f6e18f8d757797cbd.png";